// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"403":"locale-hi","543":"locale-ta","723":"locale-te"}[chunkId] || chunkId) + "." + {"403":"034b78b2","453":"deb86c0d","455":"269184ee","543":"37c36f5b","723":"d421c4e3","977":"304c1de4"}[chunkId] + ".chunk.js";
};